export default "__VITE_ASSET__DW9J7zdt__"